import { getAnalyticsId } from '@shared/core/analytics/segment/getAnalyticsId';
import { NR_ATTR_ANALYTICS_ID } from '@shared/utils/logger';
import { isChunkLoadErrorWhileUnloading } from '@shared/utils/pageUnloading';
import { withWindow } from '@shared/utils/withWindow';
import { config } from '@static/js/env.config';

export const initNewRelic = () => {
  withWindow(window => {
    const { newrelic, buildNumber } = window;

    if (newrelic) {
      newrelic.setCustomAttribute('buildNumber', buildNumber);
      newrelic.setCustomAttribute('env', config.joyEnvironment);
      newrelic.setCustomAttribute(NR_ATTR_ANALYTICS_ID, getAnalyticsId());
      newrelic.addRelease('joy-web', buildNumber);
    }
  });
};

/** Covers errors NR captures on its own (unhandled rejections), not just the ones we notice. */
export const ignoreChunkLoadErrorsWhileUnloading = () => {
  withWindow(window => {
    window.newrelic?.setErrorHandler(isChunkLoadErrorWhileUnloading);
  });
};
